import { Mic, Theater, Lightbulb, Users, Flame, Music, Wand2, Copy, VenetianMask } from "lucide-react";
import { ScrollReveal } from "./ScrollReveal";

const comedyForms = [
  { icon: Mic, title: "Stand-up", description: "Klasyczna forma komedii, gdzie komik występuje sam na scenie, dzieląc się swoimi obserwacjami i historiami." },
  { icon: Theater, title: "Kabaret", description: "Skecze i scenki komediowe w wykonaniu grupy artystów, często z wykorzystaniem rekwizytów i kostiumów." },
  { icon: Lightbulb, title: "Improwizacja", description: "Spontaniczne tworzenie scenek i historii na podstawie sugestii publiczności." },
  { icon: Users, title: "Komedia improwizowana", description: "Dłuższe formy teatralne tworzone na żywo, bez scenariusza, z aktywnym udziałem widowni." },
  { icon: Flame, title: "Roast", description: "Humorystyczne przedstawienie, gdzie zaproszeni goście żartobliwie krytykują głównego bohatera wydarzenia." },
  { icon: Copy, title: "Parodia", description: "Komiczne naśladowanie znanych osób, utworów lub zjawisk w zabawny i przejaskrawiony sposób." },
  { icon: Music, title: "Karaoke komediowe", description: "Połączenie śpiewu z elementami komedii, gdzie uczestnicy wykonują zabawne wersje znanych utworów." },
  { icon: Wand2, title: "Magik komediowy", description: "Występy łączące sztukę iluzji z elementami komedii i humoru." },
  { icon: VenetianMask, title: "Pantomima komediowa", description: "Komediowe przedstawienie bez użycia słów, oparte na gestach i mimice." },
];

export const FormsOfComedy = () => {
  return (
    <section className="py-24 md:py-32 bg-white">
      <div className="container">
        <ScrollReveal>
          <h2 className="section-heading">
            Formy <span className="gradient-text">komedii</span>
          </h2>
        </ScrollReveal>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {comedyForms.map((form, i) => {
            const Icon = form.icon;
            return (
              <ScrollReveal key={form.title} delay={i * 0.06}>
                <div className="modern-card text-center group h-full">
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-brand-purple/10 to-brand-magenta/10 flex items-center justify-center mx-auto mb-5 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                    <Icon className="w-7 h-7 text-brand-purple" />
                  </div>
                  <h3 className="text-lg font-montserrat font-bold mb-3 text-primary">{form.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{form.description}</p>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
